import React, { useState, useContext, Component } from 'react';
import { BarChart3Icon, UsersIcon, TableIcon, FileTextIcon, GlobeIcon, DollarSignIcon, PackageIcon, UmbrellaIcon, MessagesSquareIcon, ClockIcon, BuildingIcon, TruckIcon, CreditCardIcon, ListIcon, TentIcon, QrCodeIcon, SettingsIcon, ShieldIcon, SearchIcon, BellIcon, UserIcon, WarehouseIcon, ArrowRightIcon, ChevronDownIcon } from 'lucide-react';
import { FairsManagement } from '../components/admin/FairsManagement';
import { QRCodeGenerator } from '../components/admin/QRCodeGenerator';
import { UsersManagement } from '../components/admin/UsersManagement';
import { FairContext } from '../contexts/FairContext';
export function AdminPage() {
  const [activeModule, setActiveModule] = useState('dashboard');
  const [searchQuery, setSearchQuery] = useState('');
  const [showNotifications, setShowNotifications] = useState(false);
  const [currentFair, setCurrentFair] = useState(null);
  const [isGeneratingQR, setIsGeneratingQR] = useState(false);
  const {
    setActiveFair
  } = useContext(FairContext);
  const handleModuleChange = module => {
    setActiveModule(module);
  };
  const handleGenerateQR = fair => {
    setCurrentFair(fair);
    setIsGeneratingQR(true);
    setActiveModule('qrcode');
  };
  const handleQRGenerated = fairId => {
    // When QR is generated successfully, update the fair to have QR
    const updatedFair = {
      ...currentFair,
      hasQRCode: true
    };
    // Set as active fair to trigger the announcement on home page
    setActiveFair(updatedFair);
    // Log to confirm the context is updated
    console.log('QR generated for fair:', updatedFair);
    setIsGeneratingQR(false);
    setCurrentFair(null);
    setActiveModule('fairs');
  };
  const renderModuleContent = () => {
    switch (activeModule) {
      case 'fairs':
        return <FairsManagement onGenerateQR={handleGenerateQR} data-id="element-6745" />;
      case 'qrcode':
        return isGeneratingQR && currentFair ? <QRCodeGenerator fair={currentFair} onGenerated={handleQRGenerated} onCancel={() => {
          setIsGeneratingQR(false);
          setCurrentFair(null);
          setActiveModule('fairs');
        }} data-id="element-6746" /> : <div className="flex items-center justify-center h-64 bg-white/5 backdrop-blur-sm rounded-xl p-6" data-id="element-6747">
            <div className="text-center" data-id="element-6748">
              <h2 className="text-xl font-medium text-white mb-2" data-id="element-6749">
                QR Code Generator
              </h2>
              <p className="text-blue-300" data-id="element-6750">
                Please select a fair first to generate a QR code
              </p>
            </div>
          </div>;
      case 'users':
        return <UsersManagement data-id="element-6751" />;
      case 'dashboard':
        return <AdminDashboard setActiveModule={setActiveModule} data-id="element-6752" />;
      default:
        return <div className="flex items-center justify-center h-64 bg-white/5 backdrop-blur-sm rounded-xl p-6" data-id="element-6753">
            <div className="text-center" data-id="element-6754">
              <h2 className="text-xl font-medium text-white mb-2" data-id="element-6755">
                {activeModule.charAt(0).toUpperCase() + activeModule.slice(1)}{' '}
                Module
              </h2>
              <p className="text-blue-300" data-id="element-6756">This module is under development</p>
            </div>
          </div>;
    }
  };
  return <div className="flex flex-col min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950" data-id="element-6757">
      {/* Admin Header */}
      <header className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 border-b border-blue-800/30 relative z-10" data-id="element-6758">
        <div className="flex items-center justify-between px-6 py-4" data-id="element-6759">
          <div className="flex items-center" data-id="element-6760">
            <div className="p-2 mr-3 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-lg" data-id="element-6761">
              <BarChart3Icon size={20} className="text-white" data-id="element-6762" />
            </div>
            <h1 className="text-xl font-bold text-white" data-id="element-6763">Admin Dashboard</h1>
          </div>
          <div className="flex items-center space-x-3" data-id="element-6764">
            <div className="relative hidden sm:block" data-id="element-6765">
              <input type="text" placeholder="Search..." className="bg-white/10 border border-blue-800/30 rounded-full pl-10 pr-4 py-2 text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 w-56" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-6766" />
              <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-blue-300" size={18} data-id="element-6767" />
            </div>
            <div className="relative" data-id="element-6768">
              <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" onClick={() => setShowNotifications(!showNotifications)} data-id="element-6769">
                <BellIcon size={20} data-id="element-6770" />
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full text-xs flex items-center justify-center text-white" data-id="element-6771">
                  3
                </span>
              </button>
              {showNotifications && <div className="absolute right-0 mt-2 w-80 bg-gradient-to-br from-slate-800 to-blue-900 rounded-xl shadow-xl border border-blue-700/30 py-2 z-50" data-id="element-6772">
                  <div className="px-4 py-2 border-b border-blue-800/30" data-id="element-6773">
                    <h3 className="font-medium text-white" data-id="element-6774">Notifications</h3>
                  </div>
                  <div className="max-h-96 overflow-y-auto" data-id="element-6775">
                    <div className="px-4 py-3 hover:bg-white/5 border-b border-blue-800/30" data-id="element-6776">
                      <div className="flex" data-id="element-6777">
                        <div className="flex-shrink-0 mr-3" data-id="element-6778">
                          <div className="w-8 h-8 rounded-full bg-blue-500/20 flex items-center justify-center" data-id="element-6779">
                            <UsersIcon size={16} className="text-blue-400" data-id="element-6780" />
                          </div>
                        </div>
                        <div data-id="element-6781">
                          <p className="text-sm text-white" data-id="element-6782">
                            New dealer request from{' '}
                            <span className="font-medium" data-id="element-6783">
                              AgriTech Solutions
                            </span>
                          </p>
                          <p className="text-xs text-blue-300 mt-1" data-id="element-6784">
                            30 minutes ago
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="px-4 py-3 hover:bg-white/5 border-b border-blue-800/30" data-id="element-6785">
                      <div className="flex" data-id="element-6786">
                        <div className="flex-shrink-0 mr-3" data-id="element-6787">
                          <div className="w-8 h-8 rounded-full bg-amber-500/20 flex items-center justify-center" data-id="element-6788">
                            <TentIcon size={16} className="text-amber-400" data-id="element-6789" />
                          </div>
                        </div>
                        <div data-id="element-6790">
                          <p className="text-sm text-white" data-id="element-6791">
                            Upcoming fair:{' '}
                            <span className="font-medium" data-id="element-6792">Agri Expo 2023</span>{' '}
                            starts in 3 days
                          </p>
                          <p className="text-xs text-blue-300 mt-1" data-id="element-6793">
                            2 hours ago
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="px-4 py-3 hover:bg-white/5" data-id="element-6794">
                      <div className="flex" data-id="element-6795">
                        <div className="flex-shrink-0 mr-3" data-id="element-6796">
                          <div className="w-8 h-8 rounded-full bg-green-500/20 flex items-center justify-center" data-id="element-6797">
                            <DollarSignIcon size={16} className="text-green-400" data-id="element-6798" />
                          </div>
                        </div>
                        <div data-id="element-6799">
                          <p className="text-sm text-white" data-id="element-6800">
                            Price list updated for{' '}
                            <span className="font-medium" data-id="element-6801">Pivot Systems</span>
                          </p>
                          <p className="text-xs text-blue-300 mt-1" data-id="element-6802">
                            Yesterday
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="px-4 py-2 border-t border-blue-800/30" data-id="element-6803">
                    <button className="text-sm text-blue-400 hover:text-blue-300 w-full text-center" data-id="element-6804">
                      View all notifications
                    </button>
                  </div>
                </div>}
            </div>
            <div className="flex items-center bg-white/10 hover:bg-white/15 rounded-full pl-2 pr-3 py-1 cursor-pointer transition-colors" data-id="element-6805">
              <div className="bg-gradient-to-br from-blue-600 to-indigo-700 rounded-full w-8 h-8 flex items-center justify-center mr-2" data-id="element-6806">
                <UserIcon size={16} className="text-white" data-id="element-6807" />
              </div>
              <span className="text-white text-sm font-medium hidden sm:block" data-id="element-6808">
                Admin User
              </span>
              <ChevronDownIcon size={16} className="text-blue-300 ml-1 hidden sm:block" data-id="element-6809" />
            </div>
          </div>
        </div>
      </header>
      {/* Main Content */}
      <div className="flex-1 overflow-y-auto p-6" data-id="element-6810">
        {activeModule === 'dashboard' && <>
            <div className="mb-6" data-id="element-6811">
              <h1 className="text-2xl font-bold text-white" data-id="element-6812">
                Administrative configurator
              </h1>
              <p className="text-blue-300 mt-1" data-id="element-6813">
                Manage system settings, configurations, and administrative tasks
              </p>
            </div>
            {/* Product and Component Configuration */}
            <div className="mb-8" data-id="element-6814">
              <h2 className="text-xl font-semibold text-white mb-4 flex items-center" data-id="element-6815">
                <PackageIcon size={20} className="mr-2 text-blue-400" data-id="element-6816" />
                Product and Component Configuration
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-6817">
                <ConfigCard icon={<TableIcon size={24} data-id="element-6819" />} title="Matrix" description="Assignment of properties to sets and kits for validation and selection in designs." onClick={() => handleModuleChange('matrix')} data-id="element-6818" />
                <ConfigCard icon={<PackageIcon size={24} data-id="element-6821" />} title="Items" description="Management of available items/products." onClick={() => handleModuleChange('items')} data-id="element-6820" />
                <ConfigCard icon={<div className="w-6 h-6 flex items-center justify-center bg-blue-400/20 rounded text-lg font-bold" data-id="element-6823">
                      S
                    </div>} title="Span Config" description="Configuration of spans used in irrigation systems." onClick={() => handleModuleChange('span')} data-id="element-6822" />
                <ConfigCard icon={<UmbrellaIcon size={24} data-id="element-6825" />} title="Overhang Config" description="Configuration of overhangs for project designs." onClick={() => handleModuleChange('overhang')} data-id="element-6824" />
                <ConfigCard icon={<div className="w-6 h-6 flex items-center justify-center bg-blue-400/20 rounded text-lg font-bold" data-id="element-6827">
                      S
                    </div>} title="Sprinkler Config" description="Configuration of sprinklers and their technical parameters." onClick={() => handleModuleChange('sprinkler')} data-id="element-6826" />
              </div>
            </div>
            {/* Commercial and Logistics Setup */}
            <div className="mb-8" data-id="element-6828">
              <h2 className="text-xl font-semibold text-white mb-4 flex items-center" data-id="element-6829">
                <GlobeIcon size={20} className="mr-2 text-green-400" data-id="element-6830" />
                Commercial and Logistics Setup
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-6831">
                <ConfigCard icon={<GlobeIcon size={24} data-id="element-6833" />} title="Region and Countries" description="Definition of regions and countries for geographic assignment." onClick={() => handleModuleChange('regions')} data-id="element-6832" />
                <ConfigCard icon={<ListIcon size={24} data-id="element-6835" />} title="Incoterm" description="Setup of international trade terms (FOB, CIF, etc.)." onClick={() => handleModuleChange('incoterm')} data-id="element-6834" />
                <ConfigCard icon={<DollarSignIcon size={24} data-id="element-6837" />} title="Price List" description="Administration of price lists by region, customer, or product." onClick={() => handleModuleChange('pricelist')} data-id="element-6836" />
                <ConfigCard icon={<WarehouseIcon size={24} data-id="element-6839" />} title="Warehouse" description="Management of warehouses and stock locations." onClick={() => handleModuleChange('warehouse')} data-id="element-6838" />
                <ConfigCard icon={<CreditCardIcon size={24} data-id="element-6841" />} title="Payment Terms" description="Setup of payment conditions applicable to customers and quotations." onClick={() => handleModuleChange('payment')} data-id="element-6840" />
                <ConfigCard icon={<TruckIcon size={24} data-id="element-6843" />} title="Type Of Transportation" description="Configuration of logistics and transport options." onClick={() => handleModuleChange('transportation')} data-id="element-6842" />
              </div>
            </div>
            {/* Fairs and Promotions */}
            <div className="mb-8" data-id="element-6844">
              <h2 className="text-xl font-semibold text-white mb-4 flex items-center" data-id="element-6845">
                <TentIcon size={20} className="mr-2 text-amber-400" data-id="element-6846" />
                Fairs and Promotions
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-6847">
                <ConfigCard icon={<TentIcon size={24} data-id="element-6849" />} title="Agricultural Fairs" description="Register and manage agricultural fairs participation." onClick={() => handleModuleChange('fairs')} highlight={true} data-id="element-6848" />
                <ConfigCard icon={<QrCodeIcon size={24} data-id="element-6851" />} title="QR Code Generator" description="Create promotional QR codes with automatic discounts." onClick={() => handleModuleChange('qrcode')} highlight={true} data-id="element-6850" />
              </div>
            </div>
            {/* Version Control and Automations */}
            <div className="mb-8" data-id="element-6852">
              <h2 className="text-xl font-semibold text-white mb-4 flex items-center" data-id="element-6853">
                <SettingsIcon size={20} className="mr-2 text-purple-400" data-id="element-6854" />
                Version Control and Automations
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-6855">
                <ConfigCard icon={<ListIcon size={24} data-id="element-6857" />} title="Version Management" description="Control and tracking of system versions and configurations." onClick={() => handleModuleChange('version')} data-id="element-6856" />
                <ConfigCard icon={<ClockIcon size={24} data-id="element-6859" />} title="Cron Tasks" description="Scheduled tasks and system automations." onClick={() => handleModuleChange('cron')} data-id="element-6858" />
              </div>
            </div>
            {/* Other Elements */}
            <div className="mb-8" data-id="element-6860">
              <h2 className="text-xl font-semibold text-white mb-4 flex items-center" data-id="element-6861">
                <FileTextIcon size={20} className="mr-2 text-blue-400" data-id="element-6862" />
                Other Elements
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-6863">
                <ConfigCard icon={<MessagesSquareIcon size={24} data-id="element-6865" />} title="Feedback" description="Review and management of user comments or system feedback." onClick={() => handleModuleChange('feedback')} data-id="element-6864" />
                <ConfigCard icon={<ShieldIcon size={24} data-id="element-6867" />} title="iControl Remote" description="Configuration of integration with remote irrigation control systems." onClick={() => handleModuleChange('icontrol')} data-id="element-6866" />
                <ConfigCard icon={<UsersIcon size={24} data-id="element-6869" />} title="Users" description="User account management and access control." onClick={() => handleModuleChange('users')} data-id="element-6868" />
              </div>
            </div>
          </>}
        {/* Show module content when a module is selected */}
        {activeModule !== 'dashboard' && <div data-id="element-6870">
            {renderModuleContent()}
            <div className="mt-6" data-id="element-6871">
              <button onClick={() => setActiveModule('dashboard')} className="flex items-center text-blue-400 hover:text-blue-300 bg-blue-900/30 hover:bg-blue-800/50 px-4 py-2 rounded-lg transition-colors" data-id="element-6872">
                <ArrowRightIcon size={16} className="mr-2 rotate-180" data-id="element-6873" />
                Back to Admin Dashboard
              </button>
            </div>
          </div>}
      </div>
    </div>;
}
function ConfigCard({
  icon,
  title,
  description,
  onClick,
  highlight = false
}) {
  return <button onClick={onClick} className={`bg-gradient-to-br from-blue-900/70 to-indigo-900/70 backdrop-blur-sm border border-blue-700/30 rounded-lg p-6 flex flex-col items-start gap-3 hover:bg-gradient-to-br hover:from-blue-800/70 hover:to-indigo-800/70 hover:shadow-lg transition-all text-left h-full ${highlight ? 'ring-2 ring-amber-500 shadow-lg' : ''}`} data-id="element-6874">
      <div className={`text-white ${highlight ? 'bg-amber-500/20 p-2 rounded-lg' : ''}`} data-id="element-6875">
        {icon}
      </div>
      <div data-id="element-6876">
        <span className="font-medium text-white block mb-1" data-id="element-6877">{title}</span>
        <p className="text-sm text-blue-300" data-id="element-6878">{description}</p>
      </div>
    </button>;
}
function AdminDashboard({
  setActiveModule
}) {
  const stats = [{
    title: 'Total Users',
    value: 248,
    change: '+12%',
    trend: 'up',
    icon: <UsersIcon size={20} className="text-blue-400" data-id="element-6879" />,
    color: 'from-blue-600/20 to-blue-700/20',
    borderColor: 'border-blue-500/30'
  }, {
    title: 'Active Dealers',
    value: 86,
    change: '+5%',
    trend: 'up',
    icon: <BuildingIcon size={20} className="text-green-400" data-id="element-6880" />,
    color: 'from-green-600/20 to-green-700/20',
    borderColor: 'border-green-500/30'
  }, {
    title: 'Products',
    value: 1254,
    change: '+3%',
    trend: 'up',
    icon: <PackageIcon size={20} className="text-amber-400" data-id="element-6881" />,
    color: 'from-amber-600/20 to-amber-700/20',
    borderColor: 'border-amber-500/30'
  }, {
    title: 'Upcoming Fairs',
    value: 5,
    change: 'New',
    trend: 'none',
    icon: <TentIcon size={20} className="text-purple-400" data-id="element-6882" />,
    color: 'from-purple-600/20 to-purple-700/20',
    borderColor: 'border-purple-500/30'
  }];
  const quickActions = [{
    title: 'Register Fair',
    description: 'Add a new agricultural fair',
    icon: <TentIcon size={24} className="text-amber-400" data-id="element-6883" />,
    module: 'fairs',
    color: 'from-amber-600/20 to-amber-700/20',
    borderColor: 'border-amber-500/30'
  }, {
    title: 'Generate QR Code',
    description: 'Create promotional QR code',
    icon: <QrCodeIcon size={24} className="text-purple-400" data-id="element-6884" />,
    module: 'qrcode',
    color: 'from-purple-600/20 to-purple-700/20',
    borderColor: 'border-purple-500/30'
  }, {
    title: 'Manage Price Lists',
    description: 'Update product pricing',
    icon: <DollarSignIcon size={24} className="text-green-400" data-id="element-6885" />,
    module: 'pricelist',
    color: 'from-green-600/20 to-green-700/20',
    borderColor: 'border-green-500/30'
  }, {
    title: 'Configure Products',
    description: 'Manage product catalog',
    icon: <PackageIcon size={24} className="text-blue-400" data-id="element-6886" />,
    module: 'items',
    color: 'from-blue-600/20 to-blue-700/20',
    borderColor: 'border-blue-500/30'
  }];
  return <div className="space-y-6" data-id="element-6887">
      {/* Stats Overview */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-6888">
        {stats.map((stat, index) => <div key={index} className={`bg-gradient-to-br ${stat.color} backdrop-blur-sm border ${stat.borderColor} rounded-xl p-5 shadow-lg`} data-id="element-6889">
            <div className="flex justify-between items-start" data-id="element-6890">
              <div data-id="element-6891">
                <p className="text-blue-300 text-sm mb-1" data-id="element-6892">{stat.title}</p>
                <h3 className="text-white text-2xl font-bold" data-id="element-6893">
                  {stat.value.toLocaleString()}
                </h3>
              </div>
              <div className="p-2 bg-blue-900/30 rounded-lg" data-id="element-6894">{stat.icon}</div>
            </div>
            <div className="mt-4 text-sm" data-id="element-6895">
              {stat.trend === 'up' && <span className="text-green-400 flex items-center" data-id="element-6896">
                  <ArrowRightIcon size={14} className="mr-1 rotate-45" data-id="element-6897" />
                  {stat.change} from last month
                </span>}
              {stat.trend === 'down' && <span className="text-red-400 flex items-center" data-id="element-6898">
                  <ArrowRightIcon size={14} className="mr-1 -rotate-45" data-id="element-6899" />
                  {stat.change} from last month
                </span>}
              {stat.trend === 'none' && <span className="text-amber-400 flex items-center" data-id="element-6900">
                  {stat.change}
                </span>}
            </div>
          </div>)}
      </div>
      {/* Quick Actions */}
      <div className="bg-white/5 backdrop-blur-sm border border-blue-800/30 rounded-xl p-6 shadow-lg" data-id="element-6901">
        <h3 className="text-lg font-medium text-white mb-4" data-id="element-6902">Quick Actions</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-6903">
          {quickActions.map((action, index) => <button key={index} onClick={() => setActiveModule(action.module)} className={`bg-gradient-to-br ${action.color} backdrop-blur-sm border ${action.borderColor} rounded-xl p-4 text-left transition-all hover:shadow-lg flex flex-col h-full`} data-id="element-6904">
              <div className="p-3 bg-gradient-to-br from-blue-900/30 to-indigo-900/30 rounded-lg inline-flex mb-3" data-id="element-6905">
                {action.icon}
              </div>
              <h3 className="text-white font-medium" data-id="element-6906">{action.title}</h3>
              <p className="text-blue-300 text-sm mt-1" data-id="element-6907">{action.description}</p>
              <div className="mt-3 text-xs text-blue-400 flex items-center mt-auto" data-id="element-6908">
                Access
                <ArrowRightIcon size={12} className="ml-1" data-id="element-6909" />
              </div>
            </button>)}
        </div>
      </div>
    </div>;
}